import { Httpcommon } from "../../../shared/api/axiosClient";
import { InvoiceResult } from "../domain/entity/History";
import HistoryRepository from "../domain/repository/HistoryRepository";

export class TransactionApi implements HistoryRepository {
  async getTransaction(
    filterStatus: string,
    filterProduct: string,
    startDate: string,
    endDate: string,
    search: string,
    pageNumber: string,
    size: string
  ): Promise<any> {
    return await Httpcommon.get<any>(`transaction/history`, {
      params: {
        search: search || null,
        filterProduct: filterProduct || null,
        filterStatus: filterStatus || null,
        startDate: startDate || null,
        endDate: endDate || null,
        pageSize: size || null,
        pageNumber: pageNumber,
      },
    }).then((res) => res.data);
  }

  async getInvoice(
    billerid: string,
    bookid: string,
    productid: string
  ): Promise<InvoiceResult> {
    return await Httpcommon.get<InvoiceResult>(`transaction/invoice`, {
      params: {
        billerId: billerid,
        bookId: bookid,
        productId: productid,
      },
    }).then((res) => res.data);
  }

  async getGenerateLink(bookId: string): Promise<any> {
    return await Httpcommon.get<any>(`receipt/generate`, {
      params: { bookId: bookId },
    }).then((res) => res.data);
  }

  async getDetailInvoice(bookId: string): Promise<any> {
    return await Httpcommon.get<any>(`receipt/detail`, {
      params: { bookId: bookId },
    }).then((res) => res.data);
  }
}

export default TransactionApi;
